window.addEventListener("storage", (e) => {
    if (e.key === 'changeOf') {
        const val = localStorage.getItem('changeOf');
        if (val !== null) {
            const p = val.split(':');
            reloadElementsOfType(p[0], p[1]);
        }
    }
});
function reloadElementsOfType(type, id) {
    reloadRowsOfType(type, id);
    reloadSelectorsOfType(type, id);
    reloadScreensOfType(type, id);
}
function updateObject(type, id) {
    localStorage.removeItem('changeOf');
    localStorage.setItem('changeOf', type + ':' + id);
    reloadElementsOfType(type, id);
}
function reloadSelectorsOfType(type, id) {
    const fn = (() => {
        if (jQuery[type + 'Selector']) {
            return type;
        }
        const name = type.split('-').map((word) => word.substr(0, 1).toUpperCase() + word.substr(1)).join('');
        return name.substr(0, 1) .toLowerCase() + name.substr(1);
    })();

    const sel = jQuery('[data-' + type + '-selector][data-current-value="' + id + '"]');
    if (sel.length > 0) {
        eval('sel.removeClass(\'has-special-selector\').' + fn + 'Selector();');
    } else {
        (() => {
            const arr = jQuery('input[data-current-value="' + id + '"]').toArray();
            arr
                .map((item) => jQuery(item))
                .filter((item) => {
                    return item.next().is('[data-' + type + '-selector]');
                }).forEach((item) => {
                    item.removeClass('has-special-selector');
                    eval('item.' + fn + 'Selector();');
                })
        })();
    }
}
function reloadScreensOfType(type, id) {
    const $ = jQuery.noConflict();

    $('.reveal:has(meta[name="type"][content="' + type + '"]):has(meta[name="id"][content="' + id + '"])').squdeReloadAjaxPopup();
}